<template>
    <div class="address-com" v-if='model.contacts'>
      <div class="customer-info f28">
        <i class="addr-icon"></i>
        <div>
          <span>{{model.contacts}}</span>
          <span>{{model.mobile}}</span>
        </div>
      </div>
      <div class="address-info f26">
        <i></i>
        <div>地址：{{model.province}} {{model.city}} {{model.district}} {{model.address}}</div>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'address-com',
    props: {
      model : {
        type : Object,
        default : ()=>{
          return {}
        }
      }
    },
  }
</script>

<style scoped lang="scss">
  .address-com{
    width: 690px;
    height: 192px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 20px 0px rgba(0,0,0,0.1);
    border-radius:6px;
    &>div{
      &.customer-info{
        display: flex;
        line-height: 40px;
        padding-top: 30px;
        span{
          margin-right: 20px;
        }

      }
      &.address-info{
        margin-top: 20px;
        display: flex;
        div{
          width: 542px;
          line-height: 36px;
        }
      }
      & i{
        width: 32px;
        height: 36px;
        flex: none;
        margin: 0 20px 0 30px;
        &.addr-icon{
          background: url("/images/order/address-icon.png") no-repeat center;
          background-size: 28px 36px;
        }
      }
    }
  }
</style>
